// Curated REAL Vyom cinematic footage (user-supplied). Self-hosted, local paths.
// Foreign-branded clips (VALORIS "CREATE ADS", Dior) and byte-duplicates were
// excluded; faint bottom watermarks/subtitles were reframed via top-crop at encode
// time (source pixels never altered). Each clip autoplays muted, unmutes on hover.
const P = process.env.PUBLIC_URL || "";
const V = `${P}/vyom/videos`;

const mk = (slug, title, tag, blurb, orient) => ({
  slug, title, tag, blurb, orient,
  src: `${V}/${slug}.mp4`,
  poster: `${V}/${slug}.webp`,
  label: "Vyom Production Concept",
});

// Landscape cinematic productions
export const FILM_SCIFI = mk("film-scifi", "Fractured", "Sci-Fi · VFX", "A man unravels between human and machine amid a ruined world.", "16:9");
export const FILM_ACTION = mk("film-action", "Duststorm Run", "Action · Camera", "A relentless desert pursuit shot with kinetic camera language.", "16:9");
export const FILM_DRAMA = mk("film-drama", "The High Table", "Drama · Dialogue", "A tense character duel staged in a sunlit desert coliseum.", "16:9");

// Vertical cinematic stories
export const REEL_OCEAN = mk("reel-ocean", "Leviathan", "Nature · Scale", "An intimate descent beside a colossal ocean giant.", "9:16");
export const REEL_PORTRAIT = mk("reel-portrait", "Eyes of a Nation", "Portrait · Emotion", "A quiet, arresting human portrait in warm practical light.", "9:16");
export const REEL_GOLD = mk("reel-gold", "Gilded", "Beauty · Macro", "An ornate close-up study of texture, gold and skin.", "9:16");
export const REEL_ERA = mk("reel-era", "A New Era", "Fantasy · Type", "Sculpted calligraphy orbits a lone figure as a new era begins.", "9:16");

export const PRODUCTIONS = [FILM_SCIFI, FILM_ACTION, FILM_DRAMA];
export const STORIES = [REEL_OCEAN, REEL_PORTRAIT, REEL_GOLD, REEL_ERA];
export const HERO_FILM = FILM_ACTION;   // energetic hero feature panel
export const SHOWREEL = FILM_DRAMA;      // longest cinematic piece
